export enum FilterLevel {
   JustRefresh,
   Reset,
   QuickFilter,
   Site,
   Line,
   Product   
}